class ProductArchive {
    constructor() {
        this.ajaxLock = false;
        this.searchParams = new URLSearchParams(window.location.search);
        this.$ = jQuery;
        this.loadEvents();
    }

    /**
     * Method responsible for events
     * 
     */
    loadEvents() {
        let self = this;

        const currentTerm = jQuery("#products-archive").data('current-term')
        console.log(currentTerm)

        // Load current filters (if any)
        this.ajaxLoadProductResults(currentTerm, '', '', '', '');
            
        /**
         * Click event for displaying sorting option
         * 
         */
        this.$('#products-archive #sort-products').on('click', function () {
            self.$('#products-archive #sort-options').toggleClass('is-active');

            // Trigger only on mobile devices
            if (576 > self.$(window).width()) {
                if (self.$('#products-archive #sort-options').hasClass('is-active')) {
                    self.$('#products-archive #sort-options').fadeIn(100);
                } else {
                    self.$('#products-archive #sort-options').fadeOut(100);
                }
            } else {
                if (!self.$('#dark-bg').hasClass('is-active')) {
                    self.$('#dark-bg').addClass('is-active')
                } else {
                    self.$('#dark-bg').removeClass('is-active')
                }
            }
        });

        /**
         * Click event for closing sorting option
         * 
         */
        this.$('#products-archive #sort-options svg').on('click', function () {
            self.$('#products-archive #sort-options').toggleClass('is-active');

            // Trigger only on mobile devices
            if (576 > self.$(window).width()) {
                if (self.$('#products-archive #sort-options').hasClass('is-active')) {
                    self.$('#products-archive #sort-options').fadeIn(100);
                } else {
                    self.$('#products-archive #sort-options').fadeOut(100);
                }
            } else {
                if (!self.$('#dark-bg').hasClass('is-active')) {
                    self.$('#dark-bg').addClass('is-active')
                } else {
                    self.$('#dark-bg').removeClass('is-active')
                }
            }
        });

        /**
         * Click event for changing sorting order
         * 
         */
        this.$('#products-archive #sort-options .option').each(function () {
            self.$(this).on('click', function () {
                if (!self.$(this).hasClass('is-active')) {
                    let currentTerm = self.$(this).data('current-term');

                    self.searchParams.set("orderby", self.$(this).data('orderby'));
                    self.searchParams.set("order", self.$(this).data('order'));
                    history.pushState(null, '', window.location.pathname + '?' + self.searchParams.toString());

                    self.$(this).addClass('is-active').siblings().removeClass('is-active');

                    self.$('#products-archive #sort-options').toggleClass('is-active');
                    // Trigger only on mobile devices
                    if (576 > self.$(window).width()) {
                        if (self.$('#products-archive #sort-options').hasClass('is-active')) {
                            self.$('#products-archive #sort-options').fadeIn(100);
                        } else {
                            self.$('#products-archive #sort-options').fadeOut(100);
                        }
                    } else {
                        if (!self.$('#dark-bg').hasClass('is-active')) {
                            self.$('#dark-bg').addClass('is-active')
                        } else {
                            self.$('#dark-bg').removeClass('is-active')
                        }
                    }

                    self.ajaxLoadProductResults(currentTerm, '', '', '', '');
                }
            });
        });

        /**
         * Click event for displaying filter option
         * 
         */
        this.$('#products-archive .filter-option').each(function () {
            self.$(this).on('click', function () {
                let id = self.$(this).data('parentid');

                self.$('#products-archive .filter-options').removeClass('is-active');
                self.$(`#products-archive #${id}`).toggleClass('is-active');

                // Trigger only on mobile devices
                if (576 > self.$(window).width()) {
                    if (self.$(`#products-archive #${id}`).hasClass('is-active')) {
                        self.$(`#products-archive #${id}`).fadeIn(100);
                    } else {
                        self.$(`#products-archive #${id}`).fadeOut(100);
                    }
                } else {
                    if (!self.$('#dark-bg').hasClass('is-active')) {
                        self.$('#dark-bg').addClass('is-active')
                    } else {
                        self.$('#dark-bg').removeClass('is-active')
                    }
                }
            });
        });

        /**
         * Click event for closing filter option
         * 
         */
        this.$('#products-archive .filter-head').each(function () {
            self.$(this).children('svg').on('click', function () {
                let id = self.$(this).parent().parent().attr('id');
                self.$(`#products-archive #${id}`).toggleClass('is-active');

                // Trigger only on mobile devices
                if (576 > self.$(window).width()) {
                    if (self.$(`#products-archive #${id}`).hasClass('is-active')) {
                        self.$(`#products-archive #${id}`).fadeIn(100);
                    } else {
                        self.$(`#products-archive #${id}`).fadeOut(100);
                    }
                } else {
                    if (!self.$('#dark-bg').hasClass('is-active')) {
                        self.$('#dark-bg').addClass('is-active')
                    } else {
                        self.$('#dark-bg').removeClass('is-active')
                    }
                }
            });
        });

        /**
         * Click event for setting product filter
         * 
         */
        this.$('#products-archive .filter-options .filter').each(function () {
            self.$(this).on('click', function () {
                if (!self.$(this).hasClass('is-active')) {

                    let id = self.$(this).data('parentid');

                    self.searchParams.set(self.$(this).data('type'), self.$(this).data('childid'));
                    history.pushState(null, '', window.location.pathname + '?' + self.searchParams.toString());

                    self.$(this).addClass('is-active').siblings().removeClass('is-active');

                    if (!self.$('#products-archive #empty-filter').hasClass('is-active')) {
                        self.$('#products-archive #empty-filter').addClass('is-active');
                    }

                    if (self.$(`#products-archive .filter-options .result-btn[data-parentid='${id}']`).parent().hasClass('disabled')) {
                        self.$(`#products-archive .filter-options .result-btn[data-parentid='${id}']`).parent().removeClass('disabled')
                    }

                    if (!self.$(`#products-archive .filter-options .filter-foot .clear[data-parentid='${id}']`).hasClass('is-active')) {
                        self.$(`#products-archive .filter-options .filter-foot .clear[data-parentid='${id}']`).addClass('is-active')
                    }
                }
            });
        });

        /**
         * Click event for displaying products based on filters
         * 
         */
        this.$('#products-archive .filter-options .result-btn').each(function () {
            self.$(this).on('click', function () {
                let currentTerm = self.$(this).data('current-term');
                let id = self.$(this).data('parentid');

                self.$(`#products-archive #${id}`).toggleClass('is-active');

                // Trigger only on mobile devices
                if (576 > self.$(window).width()) {
                    if (self.$(`#products-archive #${id}`).hasClass('is-active')) {
                        self.$(`#products-archive #${id}`).fadeIn(100);
                    } else {
                        self.$(`#products-archive #${id}`).fadeOut(100);
                    }
                } else {
                    if (!self.$('#dark-bg').hasClass('is-active')) {
                        self.$('#dark-bg').addClass('is-active')
                    } else {
                        self.$('#dark-bg').removeClass('is-active')
                    }
                }

                self.ajaxLoadProductResults(currentTerm, '', '', '', '');
            });
        });

        /**
         * Click event for removing a single filter
         * 
         */
        this.$('#products-archive .filter-options .filter-foot .clear').each(function () {
            self.$(this).on('click', function () {
                let id = self.$(this).data('parentid');
                let activeEl = self.$(`#products-archive .filter-options .filter.is-active[data-parentid='${id}']`);

                self.searchParams.delete(self.$(activeEl).data('type'), self.$(activeEl).data('childid'));
                if ('' == self.searchParams.toString()) {
                    history.pushState(null, '', window.location.pathname);

                    if (self.$('#products-archive #empty-filter').hasClass('is-active')) {
                        self.$('#products-archive #empty-filter').removeClass('is-active');
                    }
                } else {
                    history.pushState(null, '', window.location.pathname + '?' + self.searchParams.toString());
                }

                if (self.$(this).hasClass('is-active')) {
                    self.$(this).removeClass('is-active')
                }

                self.$(activeEl).removeClass('is-active');

                if (!self.$(`#products-archive .filter-options .result-btn[data-parentid='${id}']`).parent().hasClass('disabled')) {
                    self.$(`#products-archive .filter-options .result-btn[data-parentid='${id}']`).parent().addClass('disabled')
                }
            });
        });

        /**
         * Click event for removing all filters
         * 
         */
        this.$('#products-archive #empty-filter').on('click', function () {
            let currentTerm = self.$(this).data('current-term');
            self.$('#products-archive #sort-options .option[data-orderby="title"][data-order="ASC"]').addClass('is-active').siblings().removeClass('is-active');

            self.$('#products-archive .filter-options .filter').each(function () {
                if (self.$(this).hasClass('is-active')) {
                    self.$(this).removeClass('is-active');
                }
            });

            self.$('#products-archive .filter-options .filter-foot .clear').each(function () {
                if (self.$(this).hasClass('is-active')) {
                    self.$(this).removeClass('is-active');
                }
            });

            self.$('#products-archive .filter-options .btn-wrapper').each(function () {
                if (!self.$(this).hasClass('disabled')) {
                    self.$(this).addClass('disabled');
                }
            });

            if (self.$(this).hasClass('is-active')) {
                self.$(this).removeClass('is-active');
            }

            let keysForDel = [];
            self.searchParams.forEach((value, key) => {
                keysForDel.push(key);
            });

            keysForDel.forEach(key => {
                self.searchParams.delete(key);
            });
            history.pushState(null, '', window.location.pathname);

            ajaxLoadProductResults(currentTerm, '', '', '', '');
        });

        /**
         * Click event for loading more products
         * 
         */
        this.$('#products-archive .load-more-woo-products .load-more-btn').on('click', function () {
            let currentTerm = self.$(this).data('current-term');
            let nonce = self.$(this).data('nonce');
            let totalPosts = parseInt(self.$(this).data('totalresult'));
            let perpage = self.$(this).data('perpage');
            let offset = self.$('#products-archive .loop-single-product').length;

            self.ajaxLoadProductResults(currentTerm, nonce, totalPosts, perpage, offset);
        });

        /* 
        * Hide filter option Appliceringsyta from archive pages
        *
        */
        const myText = document.getElementsByClassName('filter-products-option');

        for (let x = 0; x < myText.length; x++) {
            const p = myText[x];
            const content = p.textContent.trim();

            //if (content == 'Appliceringsyta') {
            //    p.style.display = 'none';
            //}
        }
    }

    /**
     * Ajax function for rendering posts based on filter
     *
     * @return voidsu
     */
    ajaxLoadProductResults(currentTerm, nonce, totalPosts, perpage, offset) {
        this.ajaxLock = true;
        let self = this;
        let data = {};
        data['action'] = 'mm_load_product_results';
        data['queried_object'] = currentTerm;
        '' == perpage ? (data['perpage'] = 20) : (data['perpage'] = perpage);

        if ('' != nonce) {
            data['nonce'] = nonce;
        }
        if ('' != offset) {
            data['offset'] = offset;
        }

        this.searchParams.forEach(function (value, key) {
            // Parse value to integer if condition is met
            if (key != 'order' && key != 'orderby') {
                value = parseInt(value);
            }

            // TODO: Needs proper validation ..
            data[key] = value;
        });

        const totalParams = Array.from(this.searchParams.entries()).reduce((a, x) => a+1,0);

        if(totalParams > 0) {
            self.$('.products-filter, #tax-product-archive-list').css('pointer-events','none').css('opacity','.5')

            if (!self.$('#products-archive #empty-filter').hasClass('is-active')) {
                self.$('#products-archive #empty-filter').addClass('is-active');
            }
        }

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: data,
        })
            .done(function (res) {
                self.$('.load-more-woo-products .load-more-btn').show();

                // Render content based on click event
                if (!res.btn_click) {
                    self.$('#products-archive #tax-product-archive-list').empty();
                    self.$('#products-archive #tax-product-archive-list').append(res.content);
                    self.$('#products-archive #products-count').text(`${res.total}`);

                    totalPosts = parseInt(res.total);
                } else {
                    self.$(res.content).insertAfter('#products-archive .loop-single-product:last');
                }

                let posts = self.$('#products-archive .loop-single-product').length;
                let percentage = Math.round((parseInt(posts) / parseInt(totalPosts)) * 100);

                self.$('#products-archive #progress-bar #progress').removeAttr('style');
                self.$('#products-archive #progress-bar #progress').css('width', `${percentage}%`);
                self.$('#products-archive .load-more-woo-products p').text(`Visar ${posts} av ${totalPosts}`);

                // Hide "Ladda fler" button if all products have been rendered
                if ((totalPosts - posts) <= 0) {
                    self.$('.load-more-woo-products .load-more-btn').hide();
                }

                self.ajaxLock = false;
                console.log('Success');

                console.log(res);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                self.ajaxLock = false;

                console.log(XMLHttpRequest);
                console.log(textStatus);
                console.log(errorThrown);
                console.log('Failed');
            }).always(() => {
                self.$('.products-filter, #tax-product-archive-list').css('pointer-events','all').css('opacity','1')
            })
    }

}

export default ProductArchive;